<!-- 此文件为代理文件，只是为了声明比el-cascader组件多出来的属性，方便查看,并且用于覆盖饿了么的cascader组件，所以起一样的名字 -->
<script>
import ElBuffCascader from './cascader'

export default {
	extends: ElBuffCascader,
	name: 'ElCascader',
	props: {},
	// 因为继承没办法覆盖嵌套的object，所以在创建之前把自己自定义的初始数据hack进去，形成初始数据
	beforeCreate () {
		// 以下只展示比el-cascader新增的字段，其他字段都和el-cascader一样
		this.$options.propsData.props = {
			// TODO 组件改造字段解释
			// 新增字段，必须在checkStrictly为true的情况下才有用，设置此字段会在父子独立的情况下选择父级会自动关联子级
			checkChildren: false,
			/**
			 * 新增字段，必须在checkStrictly为true的情况下才有用，设置此字段会根据checkChildren的情况进行反转
			 * 1.如果isUseCtrl为true
			 * 		1.1如果为true,则按住ctrl会不选子级
			 * 		1.2如果为false,则按住ctrl会选子级
			 * */
			isUseCtrl: false,
			/**
			 * 改造字段，把disabled字段由String改为可以传一个函数
			 * 1.如果返回false，则不禁用节点选择框
			 * 2.如果返回true，则禁用节点选择框
			 * 3.默认会给一个函数的默认值，会根据传递参数的halfSelect来确定禁用不金庸，主要是因为全局改组织的选择框工作量太大，并且还能节省代码量
			 */
			disabled: row => row.halfSelect === 2,
			...this.$options.propsData.props
		}
	}
}
</script>
